<template>
  <div class="grid-content">
    <div
      class="loading"
      v-loading="loading"
    >
      <el-form
        ref="globalPriceSettings"
        :model="globalPriceSettings"
        :rules="rules"
        label-width="200px"
        label-position="left"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="会员卡定价："
              prop="membershipCardPrice.Value"
            >
              <el-input
                :disabled="optionModel.isReadonly"
                placeholder="请输入价格"
                v-model="globalPriceSettings.membershipCardPrice.Value"
                class="input-width"
              >
                <template slot="append">$</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="会员卡续费优惠(元/月)："
              prop="renewmembershipCardPriceDiscount.Value"
            >
              <el-input
                :disabled="optionModel.isReadonly"
                placeholder="请输入价格"
                v-model="globalPriceSettings.renewmembershipCardPriceDiscount.Value"
                class="input-width"
              >
                <template slot="append">$</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <hr>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="补办会员卡定价："
              prop="renewMembershipCardPrice.Value"
            >
              <el-input
                :disabled="optionModel.isReadonly"
                placeholder="请输入价格"
                v-model="globalPriceSettings.renewMembershipCardPrice.Value"
                class="input-width"
              >
                <template slot="append">$</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="18">
            <hr>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="续办会员卡定价："
              prop="extendMembershipCardPrice.Value"
            >
              <el-input
                :disabled="optionModel.isReadonly"
                placeholder="请输入价格"
                v-model="globalPriceSettings.extendMembershipCardPrice.Value"
                class="input-width"
              >
                <template slot="append">$</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <hr>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row
      v-if="!optionModel.isReadonly"
      class="cs-filter-row"
    >
      <el-col
        :span="4"
        class="footer-left"
      >
        <el-button
          size="medium"
          :disabled="submitBtnDisable"
          :type="submitBtnClass"
          @click="saveChanges"
        >保存更新</el-button>
      </el-col>
      <el-col
        :span="16"
        class="footer-right"
      >
        <el-alert
          :closable="false"
          v-show="showError"
          v-bind:title="errorMessage"
          type="error"
          show-icon
        ></el-alert>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    overflow: visible;
    white-space: nowrap;
  }

  .el-input {
    text-align-last: center;
  }
}
</style>

<script>
import {
  getGlobalPriceSettingByType,
  saveGlobalPriceSetting
} from "../../service/globalPriceSetting.service";

export default {
  props: {
    isActive: Boolean,
    options: {
      isReadonly: Boolean
    }
  },
  data() {
    let validateValue = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入正确的价格";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      isLoadedData: false,
      loading: false,
      optionModel: {
        isReadonly: false
      },
      globalPriceSettings: {
        membershipCardPrice: {},
        renewmembershipCardPriceDiscount:{},
        renewMembershipCardPrice: {},
        extendMembershipCardPrice: {}
      },
      submitBtnClass: "info",
      submitBtnDisable: true,
      showError: false,
      errorMessage: "",
      rules: {
        membershipCardPrice: {
          Value: [
            {
              required: true,
              message: "价格不能为空",
              trigger: "blur"
            },
            {
              validator: validateValue,
              trigger: "blur"
            }
          ]
        },
        renewmembershipCardPriceDiscount:{
          Value:[
            {
              required: true,
              message:"价格不能为空",
              trigger:"blur"
            },{
              validator:validateValue,
              trigger:"blur"
            }
          ]
        },
        renewMembershipCardPrice: {
          Value: [
            {
              required: true,
              message: "价格不能为空",
              trigger: "blur"
            },
            {
              validator: validateValue,
              trigger: "blur"
            }
          ]
        },
        extendMembershipCardPrice: {
          Value: [
            {
              required: true,
              message: "价格不能为空",
              trigger: "blur"
            },
            {
              validator: validateValue,
              trigger: "blur"
            }
          ]
        }
      }
    };
  },
  components: {},
  computed: {},
  created() {
    this.loadOptionModelFromProps();
    this.loadGlobalPriceSettings();
  },
  updated() {
    this.checkAllInputs();
  },
  methods: {
    loadOptionModelFromProps(options = this.options) {
      if (!!options) {
        this.optionModel.isReadonly = options.isReadonly;
      } else {
        this.optionModel.isReadonly = false;
      }
    },
    checkAllInputs() {
      let isValid = true;

      let $refGPS = this.$refs["globalPriceSettings"];
      if (!!$refGPS) {
        $refGPS.validate(valid => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      if (isValid) {
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
      }

      return isValid;
    },
    async loadGlobalPriceSettings() {
      if (!this.isActive){
        return;
      }

      let self = this;

      this.loading = true;
      await getGlobalPriceSettingByType(4).then(result => {
        if (!!result && result.success) {
          self.globalPriceSettings.membershipCardPrice = result.data;
        }
      });

      await getGlobalPriceSettingByType(11).then(result => {
        if (!!result && result.success) {
          self.globalPriceSettings.renewmembershipCardPriceDiscount = result.data;
        }
      });

      await getGlobalPriceSettingByType(7).then(result => {
        if (!!result && result.success) {
          self.globalPriceSettings.renewMembershipCardPrice = result.data;
        }
      });

      await getGlobalPriceSettingByType(14).then(result => {
        if (!!result && result.success) {
          self.globalPriceSettings.extendMembershipCardPrice = result.data;
        }
      });
      this.loading = false;
      this.isLoadedData = true;
    },
    async saveChanges() {
      let self = this;

      let isValid = this.checkAllInputs();
      if (!isValid) {
        return;
      }

      let cacheSubmitBtnDisable = this.submitBtnDisable;
      this.submitBtnDisable = true;

      let showError = false;
      let errorMessage = "";

      let result1 = await saveGlobalPriceSetting(
        this.globalPriceSettings.membershipCardPrice
      );
      if (!!result1) {
        if (result1.success) {
          self.globalPriceSettings.membershipCardPrice.Id = result1.data;
        } else {
          showError = true;
          errorMessage += result1.message;
        }
      }

      let result2 = await saveGlobalPriceSetting(
        this.globalPriceSettings.renewMembershipCardPrice
      );
      if (!!result2) {
        if (result2.success) {
          self.globalPriceSettings.renewMembershipCardPrice.Id = result2.data;
        } else {
          showError = true;
          errorMessage += result2.message;
        }
      }

      let result3 = await saveGlobalPriceSetting(this.globalPriceSettings.renewmembershipCardPriceDiscount);
      if(!!result3){
        if(result3.success){
          self.globalPriceSettings.renewmembershipCardPriceDiscount.Id = result3.data;
        }else{
          showError = true;
          errorMessage += result3.message;
        }
      }
      let result4 = await saveGlobalPriceSetting(this.globalPriceSettings.extendMembershipCardPrice);
      if(!!result4){
        if(result4.success){
          self.globalPriceSettings.extendMembershipCardPrice.Id = result4.data;
        }else{
          showError = true;
          errorMessage += result4.message;
        }
      }


      if (!this.showError) {
        this.$message({
          message: "保存更新成功",
          type: "success"
        });
      }
      this.showError = showError;
      this.errorMessage = errorMessage;

      this.submitBtnDisable = cacheSubmitBtnDisable;
    }
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
          this.loadGlobalPriceSettings();
      }
    },
    options: function(newVal) {
      this.loadOptionModelFromProps(newVal);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/memberCardPrice.vue